<!--
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-21 14:10:25
 * @Description: 
-->
<template>
    <div>
        <VueUeditorWrap v-model="message" :config="editorConfig"/>
    </div>
</template>
<script>
    import VueUeditorWrap from 'vue-ueditor-wrap'
    export default {
        name: "Editor",
        components: {
            VueUeditorWrap
        },
        props: ["content"],
        data() {
            return {
                editor: null, // ediotr实例
                message: '', // editor内容
                // 简单配置
                editorConfig: {
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: 300,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    // 上传文件接口, 报错属于正常，若需要验证可使用(也是盗大神的)http://35.201.165.105:8000/controller.php
                    // 调试完毕打包上线则切换回/static/UEditor/php/controller.php即可，不用做其他处理
                    //serverUrl: this.$publicData.serverUrl,
                    serverUrl: '/common/ueditor_upload',
                    UEDITOR_HOME_URL: '/statics/UEditor/'
                }
            };
        },
        mounted() {
            // 这里是从列表页编辑时做的内容注入，没有需要可以不写
            this.message = this.content;
        },
   methods: {
       ready(editor) {
           // 这里可以拿到ueditor的实例，比如editor.getContent()就可以拿到编辑器的html内容
           // 把获取到的editor实例绑定到数据editor中，这样用this.editor.getContent()就可以随地拿到编辑器的html内容
           this.editor = editor;
       }
   }
    };
</script>

